import ReactDOM from "react-dom";
import cn from "classnames";
import { Button } from "../Button";
import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { useTranslation } from "../../hooks/useTranslation";
import { twMerge } from "tailwind-merge";
import { useScrollLock } from "usehooks-ts";

export type SimpleModalProps = {
  title: string | null;
  children: any;
  showButtons?: boolean;
  disableSuccess?: boolean;
  isSuccessLoading?: boolean;
  onSuccess?: () => void;
  onCancel: () => void;
  className?: string;
};

export const SimpleViewModal: React.FC<SimpleModalProps> = ({
                                                   title,
                                                   disableSuccess,
                                                   isSuccessLoading = false,
                                                   children,
                                                   className,
                                                   showButtons = true, onSuccess,
                                                   onCancel
                                                 }) => {
  const { t } = useTranslation();
  const { lock, unlock } = useScrollLock({
    autoLock: false
  });

  useEffect(() => {
    lock();
    return () => unlock();
  }, []);

  const modalPortal = document.getElementById("modal-portal");
  return (
    <>
      {ReactDOM.createPortal(
        <div
          className="z-3"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          <div className="fixed  inset-0">
            <div className="flex max-h-[100vh] h-full items-end sm:items-center justify-center p-4 text-center sm:p-0">
              <div
                className={twMerge(
                  cn(
                    "bg-gray-50 rounded-lg dark:bg-neutral-700 text-left overflow-hidden shadow-xl transform transition-all w-6/12 ",
                    className
                  )
                )}
              >
                <div className="bg-gray-50 h-full px-2 pt-4 dark:bg-neutral-700">
                  <div className="w-full h-full dark:bg-neutral-700">
                    <div className="mt-1 mx-2 h-full">
                      <div className={"flex flex-row"}>
                        <h3
                          className="text-2xl w-full leading-6 font-medium text-gray-500 dark:text-white"
                          id="modal-title"
                        >
                          {title}
                        </h3>
                        <FontAwesomeIcon
                          icon={faXmark}
                          className={"mr-1 justify-end cursor-pointer"}
                          onClick={onCancel}
                        />
                      </div>
                      <hr />
                      <div
                        className="max-h-[calc(100vh-250px)] px-1 overflow-y-auto my-3 w-full text-sm text-gray-500 dark:text-white">
                        {children}
                      </div>
                    </div>
                  </div>
                </div>

                {showButtons &&
                  <div className="bg-gray-50 px-4 py-3 dark:bg-neutral-600 gap-2 sm:px-6 sm:flex sm:flex-row-reverse">
                    {onSuccess && (
                      <Button
                        loading={isSuccessLoading}
                        disabled={disableSuccess}
                        label={`${t("confirm")}`}
                        onClick={onSuccess}
                      />
                    )}
                    <Button label={`${t("cancel")}`} onClick={onCancel} />
                  </div>
                }

              </div>
            </div>
          </div>
        </div>,
        modalPortal as Element
      )}
    </>
  );
};
